import { render, staticRenderFns } from "./titleManage.vue?vue&type=template&id=65fcaf09&scoped=true&"
import script from "./titleManage.vue?vue&type=script&lang=ts&"
export * from "./titleManage.vue?vue&type=script&lang=ts&"
import style0 from "./titleManage.vue?vue&type=style&index=0&id=65fcaf09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fcaf09",
  null
  
)

export default component.exports